import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Icon, ButtonMenu } from "@ann/web-components";
import { HeaderContainer, TitleContainer, IconWrapper } from "./Header.styled";

const Header = ({ title, onMenuChange }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/v2/knowledge");
  };

  const handleMenuChange = async (value) => {
    if (onMenuChange) {
      onMenuChange(value);
    }
    console.log("Menu action:", value);
  };

  return (
    <HeaderContainer>
      <TitleContainer>
        <IconWrapper onClick={handleBackClick}>
          <Icon name="arrowLeft" size="medium" />
        </IconWrapper>
        {title && (
          <Typography category="title" size="large" weight="bold">
            {title}
          </Typography>
        )}
      </TitleContainer>

      <ButtonMenu
        iconPosition="right"
        label="Actions"
        menuPosition="bottom"
        onChange={handleMenuChange}
        size="medium"
        type="gradient"
        width="230px"
      >
        <ButtonMenu.Menu icon={true}>
          <ButtonMenu.Item
            label="Add Facts"
            value="add-facts"
            icon='plus'
          />
          <ButtonMenu.Item
            label="Train"
            value="train"
            icon='bolt'
          />
          <ButtonMenu.Item
            label="Add Users"
            value="add-users"
            icon='personAdd'
          />
        </ButtonMenu.Menu>
      </ButtonMenu>
    </HeaderContainer>
  );
};

export default Header;

